import { AxiosError } from 'axios';
import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Row, Col } from 'reactstrap';

import { forgotPassSendVerificationCodeRequest } from '@reducers/auth/AuthAction';
import { handleError } from '@services/ErrorHandler';
import { CustomButton } from '@shared/buttons';
import InputField from '@shared/components/input/InputField';
import { VERIFICATION_TYPES } from '@shared/constants';
import useTranslation from '@shared/hooks/useTranslation';
import {
  CloseIcon,
} from '@shared/icons';

import '../ForgotPasswordModal.scss';

type IForgotPasswordContent = {
  onNext: () => void;
  onToggle: () => void;
};

const ForgotPasswordContent = ({ onNext, onToggle }: IForgotPasswordContent) => {
  const i18n = useTranslation('general');
  const title = useTranslation('forgotPassword.title');
  const description = useTranslation('forgotPassword.description');
  const sendVerification = useTranslation('verification.button.send_verification');
  const [ email, setEmail ] = useState('');
  const [ isSending, setSending ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState('');
  const dispatch = useDispatch<any>();

  const handleVerify = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSending(true);
    try {
      await dispatch(forgotPassSendVerificationCodeRequest({
        email,
        email_or_mobile: email,
        type: VERIFICATION_TYPES.forgot_password,
      })).$promise;
      onNext();
    } catch (error) {
      const { response: errorResponse } = error as AxiosError;
      if (errorResponse) {
        setErrorMessage(errorResponse.data?.message);
        return;
      }
      handleError(error);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="forgot-password-content-container">
      <Row className="mb-3">
        <Col className="fp-close-button-style">
          <a aria-label="Close" role="button" href="#" onClick={onToggle}><CloseIcon /></a>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="s2 forgot-password-modal-title mb-5">{title}</div>
          <div className="b1 mb-2">{description}</div>
          <Form id="forgot-password-form" onSubmit={handleVerify}>
            <InputField
              id="forgot-password-email"
              label={i18n.input.email.label}
              placeholder={i18n.input.email.placeholder}
              onInputChangeHandler={(value) => setEmail(value)}
              type="email"
              name="email"
              value={email}
              fieldError={errorMessage}
            />
            <CustomButton
              id="btn-send"
              loading={isSending}
              disabled={isSending || isEmpty(email)}
              color="primary"
              className="btn-lg"
              type="submit"
            >
              {sendVerification}
            </CustomButton>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPasswordContent;
